<template>
  <span class="badge badge-default in-progress-badge">
    {{ $t('common.in_progress') }}
  </span>
</template>

<script>
  export default {
    name: 'in-progress-badge',
  };
</script>



// WEBPACK FOOTER //
// src/components/InProgressBadge.vue